import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';

export const useQuoteSummaryOverviewStyles = createStyles(({ token }) => {
  const detailsGridItem = {
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
  };
  const label = {
    color: ThemeColors.COLOR_GREY_BLUISH2,
    fontSize: token.fontSizeSM,
    textTransform: 'uppercase',
  };
  const value = {
    fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
    color: token.colorPrimary,
    fontWeight: 700,
    textOverflow: 'ellipsis',
    display: 'inline-block',
    maxWidth: 150,
    overflow: 'hidden',
  };
  const labelSmall = {
    textTransform: 'uppercase',
    minWidth: 110,
    display: 'inline-block',
    color: ThemeColors.COLOR_GREY_BLUISH2,
    fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
    fontWeight: 400,
    fontFamily: token.fontFamily,

    [`@media (min-width: ${token.screenMDMin}px)`]: {
      fontSize: token.fontSizeSM,
      minWidth: 130,
    },
  };
  const valueSmall = {
    color: ThemeColors.COLOR_GREY3,
    fontSize: token.fontSizeSM,
    fontWeight: 700,

    [`@media (min-width: ${token.screenMDMin}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  };

  return {
    detailsGridItem,
    value,
    labelFirst: { ...label, minWidth: 50 },
    labelSecond: { ...label, minWidth: 90 },
    labelLast: { ...label, minWidth: 145 },

    detailsGridItemSmall: {
      paddingRight: ThemeSpaces.SPACE_NORM,
    },
    detailsGridItemSecondSmall: {
      paddingRight: ThemeSpaces.SPACE_NORM,
      display: 'flex',
    },
    valueSmall,
    valueSecondSmall: {
      ...valueSmall,
      display: 'inline-block',
      minWidth: '50%',
      verticalAlign: 'top',
    },
    labelFirstSmall: labelSmall,
    // The "-second" variant always wins over the responsive min-width above
    // (equal specificity, declared later in the original LESS), regardless
    // of breakpoint — so this omits the media query rather than overriding it.
    labelSecondSmall: {
      textTransform: 'uppercase',
      display: 'inline-block',
      color: ThemeColors.COLOR_GREY_BLUISH2,
      fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
      fontWeight: 400,
      fontFamily: token.fontFamily,
      minWidth: 60,
    },
  };
});
